import React from 'react';
import styles from './render-chat-messages.module.scss';
import { KnowledgeWrapperComponent } from 'src/pages/application/knowledge/components/knowledge-row';
import { useKnowledgeItems } from 'shared/hooks/knowledge-items.hooks';
import { SourcesCollapse } from '../sources-collapse';
import { useChatConversation } from '../../hooks/use-chat-conversation';
import { ANSWER_STATE, EVENTS } from 'shared/constants';
import analyticsService from 'src/helpers/analytics.service';
import { ListItemsNavigator } from 'src/components/common/items-navigator';
import { formatNumber } from 'shared/utils';

export function MessageResources({ message, excludeKnowledgeItemId }) {
  const { lang, conversationId } = useChatConversation();

  const {
    data: items = [],
    isPending,
    isError,
  } = useKnowledgeItems(
    (message.resources ?? [])
      .map(({ knowledgeItemId }) => knowledgeItemId)
      .filter(id => id !== excludeKnowledgeItemId),
  );

  if (!message.resources?.length) {
    return <></>;
  }

  // No count while the rows load or when the request failed: `(0)` would read
  // as "no resources".
  const header =
    isPending || isError
      ? lang.RELATED_RESOURCES
      : `${lang.RELATED_RESOURCES} (${formatNumber(items.length)})`;

  return (
    <SourcesCollapse
      onOpen={() => {
        analyticsService.track(EVENTS.AI_CHAT.OPEN_RESOURCES, { conversationId });
      }}
      expended={message.state === ANSWER_STATE.ONLY_RESOURCES_FOUND}
      header={<p className={styles.collapseHeader}>{header}</p>}>
      <ListItemsNavigator orientation="vertical" className={styles.resourcesPanel}>
        {items.map(item => (
          <KnowledgeWrapperComponent key={item.id} item={item} />
        ))}
      </ListItemsNavigator>
    </SourcesCollapse>
  );
}
